import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout as clearSession, getUserName } from '../../utils/authUtils.ts';

const Header = ({ sidebarOpen, setSidebarOpen, activeTab }) => {
  const navigate = useNavigate();

  // Authentication check on component mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    const userName = getUserName();
    if (!token || !userName) {
      navigate("/login");
    }
  }, [navigate]);

  // Logout function
  const logout = () => {
    clearSession();
    navigate("/login");
  };

  // Function to get display name for active tab
  const getTabDisplayName = (tabId) => {
    const tabNames = {
      'dashboard': 'Dashboard',
      'history': 'History',
      'analytics': 'Analytics',
      'knowledgebase': 'Knowledgebase',
      'test-text-chat': 'Text Chat',
      'test-voice-chat': 'Voice Chat',
      'settings': 'Settings',
      'support': 'Support'
    };
    return tabNames[tabId] || 'Qurve AI';
  };

  return (
    <header className="bg-gray-800 shadow-md h-16 flex items-center justify-between px-6 z-10">
      <button
        className="text-gray-300 hover:text-white focus:outline-none md:hidden cursor-pointer"
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        <i className={`fas ${sidebarOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
      </button>

      <h1 className="text-xl font-bold text-white">{getTabDisplayName(activeTab)}</h1>

      <button
        onClick={logout}
        className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md flex items-center !rounded-button whitespace-nowrap cursor-pointer"
      >
        <i className="fas fa-sign-out-alt mr-2"></i>
        Sign Out
      </button>
    </header>
  );
};

export default Header;
